import React, { forwardRef } from 'react';
import { css, cx } from '@emotion/css';
const stackStyles = (alignItems, flexDirection, justifyContent, spacing, flex) => css `
  ${alignItems && `align-items: ${alignItems}`};
  ${flexDirection && `flex-direction: ${flexDirection}`};
  ${justifyContent && `justify-content: ${justifyContent}`};
  ${flex && `flex: ${flex}`};
  display: flex;
  gap: ${spacing};
`;
export const Stack = forwardRef(({ alignItems, as = 'div', children, className, flex, flexDirection, justifyContent, spacing = '12px', testId, ...rest }, ref) => {
    const stackClasses = cx(stackStyles(alignItems, flexDirection, justifyContent, spacing, flex), className, 'ds-stack');
    return React.createElement(as || 'div', {
        className: stackClasses,
        'data-testid': testId,
        ref,
        ...rest,
    }, children);
});
Stack.displayName = 'Stack';
